import React from "react";
import SecurityAlertContent from "../components/SecurityAlert/SecurityAlertContent";
import "../css/SecurityAlertPage.css";

const SecurityAlert = () => {
  return (
    <section className="security-alert-page-simple">
      <div className="security-alert-page-simple__container">
        <h1 className="security-alert-page-simple__title">Security Alert</h1>
        <div className="security-alert-card">
          <SecurityAlertContent
            headingId="security-alert-heading-desktop"
            domain="udhaarportal.com"
            teamName="Udhaar Portal"
          />
        </div>
        <div className="security-alert-card--mobile">
          <SecurityAlertContent
            headingId="security-alert-heading-mobile"
            domain="udhaarportal.com"
            teamName="Udhaar Portal"
          />
        </div>
      </div>
    </section>
  );
};

export default SecurityAlert;
